module.exports = __webpack_public_path__ + "img/c_v1.08e3de9.png";